import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { NorthEast, SouthEast, ChevronRight } from '@mui/icons-material';

// Admin UI kit (design-system.md §12.2)

export const condensed = { fontWeight: 700, sx: { fontStretch: '75%' } };

export const AdminCard = ({ title, action, onAction, children, ...rest }) => (
    <Box bg='raano.white' border='1px solid' borderColor='raano.border' borderRadius='12px' p={{ base: '16px', md: '20px' }} {...rest} >
        {(title || action) &&
            <Box display='flex' justifyContent='space-between' alignItems='center' mb='12px' gap='8px' >
                <Text fontSize='15px' fontWeight={600} >{title}</Text>
                {action && <Box as='button' display='inline-flex' alignItems='center' fontSize='13px' fontWeight={500} textDecoration='underline' onClick={onAction} >{action}<ChevronRight sx={{ fontSize: 16 }} /></Box>}
            </Box>}
        {children}
    </Box>
);

// Signed change vs the previous period; up is good for sales
export const Delta = ({ current, previous }) => {
    if (!previous) return <Text fontSize='12px' color='raano.muted' >No earlier sales to compare</Text>;
    const change = ((current - previous) / previous) * 100;
    const up = change >= 0;
    return (
        <Box display='inline-flex' alignItems='center' gap='4px' fontSize='13px' fontWeight={600} color={up ? '#1E6B3A' : 'raano.error'} >
            {up ? <NorthEast sx={{ fontSize: 14 }} /> : <SouthEast sx={{ fontSize: 14 }} />}
            {up ? '+' : ''}{change.toFixed(0)}%
            <Box as='span' color='raano.muted' fontWeight={400} >vs previous</Box>
        </Box>
    );
};

export const KpiTile = ({ label, value, sub, onClick, hero = false }) => (
    <Box as={onClick ? 'button' : 'div'} textAlign='left' onClick={onClick} bg='raano.white' border='1px solid' borderColor='raano.border' borderRadius='12px' p={{ base: '16px', md: '20px' }}
        transition='border-color .125s' _hover={onClick ? { borderColor: 'raano.black' } : undefined} >
        <Text fontSize='13px' fontWeight={500} color='raano.muted' >{label}</Text>
        <Text {...condensed} fontSize={hero ? { base: '44px', md: '56px' } : { base: '26px', md: '30px' }} lineHeight={1.05} mt='6px' >{value}</Text>
        {sub && <Box mt='6px' fontSize='12px' color='raano.muted' >{sub}</Box>}
    </Box>
);

// Pill group; active segment black (date ranges, status filters)
export const Segmented = ({ options, value, onChange, label }) => (
    <Box role='tablist' aria-label={label} display='inline-flex' p='3px' gap='2px' bg='raano.white' border='1px solid' borderColor='raano.border' borderRadius='full' maxWidth='100%' overflowX='auto' sx={{ scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }} >
        {options.map(o => {
            const active = o.value === value;
            return (
                <Box key={o.value} as='button' role='tab' aria-selected={active} flexShrink={0} height='30px' px='14px' borderRadius='full' fontSize='13px' fontWeight={500}
                    bg={active ? 'raano.black' : 'transparent'} color={active ? 'raano.white' : 'raano.black'} transition='background .125s, color .125s'
                    _hover={active ? undefined : { bg: 'raano.surface' }} onClick={() => onChange(o.value)} >
                    {o.label}{o.count !== undefined && <Box as='span' ml='6px' opacity={0.6} >{o.count}</Box>}
                </Box>
            );
        })}
    </Box>
);

// Thin horizontal meter (share of total)
export const Meter = ({ value, color = 'raano.black' }) => (
    <Box height='6px' bg='#EDEDED' borderRadius='full' overflow='hidden' >
        <Box height='100%' width={`${Math.max(0, Math.min(100, value))}%`} bg={color} borderRadius='full' transition='width .4s ease-out' />
    </Box>
);
